import script from "./ds-modal-dialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./ds-modal-dialog.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__